;(function ($) {
    // ie img object-fit polyfill for all images
    // objectFitImages();
    //ie sticky polyfill for nav
    // var elements = document.querySelectorAll(".mci-nav");
    // Stickyfill.add(elements);

    // const searchInput = document.querySelector(".mci-nav__menu__items-row__search-wrapper input");
    // const searchButton = document.querySelector(".mci-nav__menu__items-row__search-wrapper #menuSearchButton");
    // const menuItems = Array.from(document.querySelectorAll(".mci-nav__menu__items-row__link-list__link"));
    // const menuBtn = document.getElementById("menuBtn");
    // const nav = document.querySelector(".mci-nav");
    // let ticking = false;
    // startMenuListeners();

    // // this might help edge sticky nav bug on production
    // function clearEdgeSticky(elem) {
    //     elem.style.right = elem.style.right === "0.1px" ? "0px" : "0.1px";
    // }

    // function setMenuItemsTabIndex(index) {
    //     if (searchInput) {
    //         searchInput.setAttribute("tabindex", index);
    //     }
    //     if (searchButton) {
    //         searchButton.setAttribute("tabindex", index);
    //     }

    //     if (menuItems.length > 0) {
    //         menuItems.forEach(function (el) {
    //             el.setAttribute("tabindex", index);
    //         });
    //     }
    // }

    // function startMenuListeners() {
    //     if (menuBtn && nav) {
    //         menuBtn.addEventListener("click", function (e) {
    //             handleMenuButtonClick("click");
    //         });
    //     }

    //     //if is xl screen auto open menu when page loads at top
    //     if (window.innerWidth > 1024) {
    //         if (window.pageYOffset > 54) {
    //             nav.classList.add("mci-nav--scrolling");
    //             nav.classList.remove("mci-nav--active");
    //         } else if (window.pageYOffset < 1) {
    //             nav.classList.add("mci-nav--active");
    //             nav.classList.remove("mci-nav--scrolling");
    //         }
    //     } else {
    //         if (window.pageYOffset > 54) {
    //             nav.classList.add("mci-nav--scrolling");
    //         } else if (window.pageYOffset < 1) {
    //             nav.classList.remove("mci-nav--scrolling");
    //         }
    //     }
    //     clearEdgeSticky(nav);

    //     window.addEventListener("scroll", function () {
    //         if (!ticking) {
    //             window.requestAnimationFrame(function () {
    //                 //if is xl screen auto open menu when page loads at top
    //                 if (window.innerWidth > 1024) {
    //                     if (window.pageYOffset > 54) {
    //                         nav.classList.add("mci-nav--scrolling");
    //                         nav.classList.remove("mci-nav--active");
    //                         setMenuItemsTabIndex(-1);
    //                     } else if (window.pageYOffset < 1) {
    //                         nav.classList.add("mci-nav--active");
    //                         nav.classList.remove("mci-nav--scrolling");
    //                         setMenuItemsTabIndex(0);
    //                     }
    //                 } else {
    //                     if (window.pageYOffset > 54) {
    //                         nav.classList.add("mci-nav--scrolling");
    //                     } else if (window.pageYOffset < 1) {
    //                         nav.classList.remove("mci-nav--scrolling");
    //                     }
    //                 }

    //                 ticking = false;
    //             });
    //             clearEdgeSticky(nav);
    //             ticking = true;
    //         }
    //         let lastScrollPosition = window.pageYOffset;
    //     });
    // }

    // function handleMenuButtonClick(eventType) {
    //     if (nav.classList.contains("mci-nav--active")) {
    //         nav.classList.remove("mci-nav--active");
    //         setMenuItemsTabIndex(-1);
    //     } else {
    //         nav.classList.add("mci-nav--active");
    //         setMenuItemsTabIndex(0);
    //     }
    // }

    $(".mci-nav .mci-nav__open-btn").click(function () {
        $(".mci-nav").toggleClass("mci-nav--open");
        $(".mci-nav .mci-nav__open-btn").attr("tabindex", "-1");
        $(".mci-nav .mci-nav__close-btn").attr("tabindex", "0");
        $(".uhf-header").css('z-index', '100');
    });
    $(".mci-nav .mci-nav__close-btn").click(function () {
        $(".mci-nav").toggleClass("mci-nav--open");
        $(".mci-nav .mci-nav__open-btn").attr("tabindex", "0");
        $(".mci-nav .mci-nav__close-btn").attr("tabindex", "-1");
        $(".uhf-header").css('z-index', 'initial');
    });

    function playButtonClicked() {
        console.log("play clicked");
    }

    // console.log(document.getElementsByClassName("mci-container")[0].getBoundingClientRect().width);
    if (document.getElementsByClassName("mci-container")[0]) {
        document.querySelector("body").style.setProperty("--container-width", `${document.getElementsByClassName("mci-container")[0].getBoundingClientRect().width}px`);
    }
    setTimeout(() => {
        if (document.getElementsByClassName("mci-container")[0]) {
            document.querySelector("body").style.setProperty("--container-width", `${document.getElementsByClassName("mci-container")[0].getBoundingClientRect().width}px`);
        }
    }, 2000);
    window.addEventListener("resize", () => {
        if (document.getElementsByClassName("mci-container")[0]) {
            document.querySelector("body").style.setProperty("--container-width", `${document.getElementsByClassName("mci-container")[0].getBoundingClientRect().width}px`);
        }
    });

    // $('.reveal__fade-up').each((ind, el) => {
    //     console.log(el, typeof el)
    //     gsap.from(el, {
    //         scrollTrigger: {
    //             trigger: el, // start the animation when ".box" enters the viewport (once)
    //             start: "center bottom",
    //             markers: true,
    //         },
    //         y: 20,
    //         autoAlpha: 0,
    //         duration: 0.5,
    //     });
    // });

    window.convertRange = function convertRange(value, oldRange, newRange) {
        return ((value - oldRange.min) * (newRange.max - newRange.min)) / (oldRange.max - oldRange.min) + newRange.min;
      }
})(jQuery);

// (function () {

//     // playButtonClicked();
// })();
